module.exports = __webpack_public_path__ + "static/media/birth-cert-step3.ae9e3465.png";